import {Locale} from '../../../provider/locale/localization';
import {useModal} from '../../../provider/modal/modal-hook';
import {useUser} from '../../../provider/user/user-hook';

export function useAddToFavoritesModal(): (path: string, childPath: Array<string>) => void {
    const {modal} = useModal();
    const {addFavorite} = useUser();

    return (path: string, childPath: Array<string>) => {
        modal.confirm({
            title: <Locale stringKey="NAVIGATION__ADD_TO_FAVORITES__TITLE" />,
            content: <Locale stringKey="NAVIGATION__ADD_TO_FAVORITES__DESCRIPTION" />,
            cancelText: <Locale stringKey="POPUP__BUTTON__CANCEL" />,
            okText: <Locale stringKey="NAVIGATION__ADD_TO_FAVORITES__ADD_BUTTON" />,
            onOk: () => {
                return addFavorite(path, childPath);
            },
        });
    };
}
